/* eslint-disable max-len */
import React,{useState} from 'react'
import { CamelCase } from '../../redux/helper/CamelCase';
import ThreeDotsLoader from '../LoadingDots';
import Modal from 'react-modal'

export default function CreateModal({handleCreate,setmodalType,type,isCreate,setisCreate}) {
    const [wishName, setwishName] = useState('');
    const [loading, setloading] = useState(false)
    return (
        <Modal isOpen={isCreate}>
            <div className="modal-dialog modal-dialog-centered relative sm:max-w-[398px] w-full px-3 pointer-events-none mx-auto" style={{ margin: 'auto' }}>
                <div className="modal-content border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
                    <div className="modal-header flex flex-shrink-0 items-center justify-between pt-[26px] rounded-t-md">
                        <h5 className="sm:text-xl text-base font-semibold text-[#090406] text-center w-full" id="exampleModalScrollableLabel1">
                            <>Create Wishlist</>
                        </h5>
                        <button type="button"
                            onClick={()=>setisCreate(false)}
                            className="btn-close1 box-content sm:w-4 sm:h-4 w-3 h-3 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline absolute sm:top-[4px] sm:right-1 top- right-4"
                            data-bs-dismiss="modal" aria-label="Close">
                        </button>
                    </div>
                    <>
                        <div>
                            <div className="modal-body relative sm:px-8 px-3 sm:pt-7 pt-5">
                                <input type="text"
                                    value={wishName}
                                    onChange={(e)=>setwishName(e.target.value)}
                                    className="bg-[#FFFFFF] border-[#E9E9E9] border sm:px-[18px] px-3 py-3 rounded-lg w-full outline-0 sm:text-base text-sm font-normal text-[#090406] placeholder:text-sm placeholder:font-normal placeholder:text-[#A5A5A5]" placeholder="Enter New Wishlist Name" />
                            </div>
                            <div className="modal-footer flex flex-shrink-0 flex-wrap items-center justify-center pt-6 pb-[18px] border-gray-200 rounded-b-md">
                                <button 
                                    disabled={wishName.length === 0 }
                                    onClick={()=>{
                                        setloading(true)
                                        handleCreate(wishName,type,'diff');
                                        setTimeout(() => {
                                            setmodalType('')
                                            setloading(false)
                                        }, 2000);
                                    }}
                                    type="button" className="w-fit px-8 py-2 bg-[#555259] text-white sm:text-base text-sm font-semibold leading-tight rounded-lg transition duration-150 ease-in-out update-wishlist flex justify-center items-center"
                                    data-bs-dismiss="modal" data-bs-toggle="modal" data-bs-target="#editWishlist">
                                    <>{loading?<ThreeDotsLoader/>:<>{CamelCase(type)} Wishlist</>}</>
                                </button>
                            </div>
                        </div> 
                
                    </>
                </div>
            </div>
        </Modal>
    )
}
